<template>
  <div id="container">
  	<div v-if="language == 'de'" style="white-space: pre-line;">
			Sie befinden sich auf der Homepage der Firma
			<address>
			<b>schuett-biotec GmbH</b><br>
			<b>Rudolf-Wissell-Str. 13</b><br>
			<b>D-37079 G&ouml;ttingen</b><br>
			<b>Deutschland</b>
			Fon +49 (0) 551/5 04 10-0
			Fax +49 (0) 551/5 04 10-99
			<a href="">E-Mail</a><br>
			<a href="http://www.schuett-biotec.de">www.schuett-biotec.de</a>
			</address>
			Gesch&auml;ftsf&uuml;hrerin:

			Andrea Arndt

			Registergericht:

			Amtsgericht G&ouml;ttingen

			Handelsregisternummer:

				HRB 43 67

			Umsatzsteuer-Identifikationsnummer (gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz):

				DE 247 271 380

			Trotz sorgf&auml;ltiger inhaltlicher Kontrolle &uuml;bernehmen wir keine Haftung f&uuml;r die Inhalte externer Links. F&uuml;r den Inhalt der verlinkten Seiten sind ausschlie&szlig;lich deren Betreiber verantwortlich.

			Z&ouml;gern Sie nicht Kontakt mit uns aufzunehmen, wenn Sie spezielle Fragen haben.


			Wir sind stets bem&uuml;ht, unser Webangebot aktuell und inhaltlich richtig sowie vollst&auml;ndig anzubieten. Dennoch ist das Auftreten von Fehlern nicht v&ouml;llig auszuschliessen. Die Firma schuett-biotec GmbH &uuml;bernimmt keine Haftung f&uuml;r die Aktualit&auml;t, die inhaltliche Richtigkeit sowie f&uuml;r die Vollst&auml;ndigkeit der in ihrem Webangebot eingestellten Informationen, es sei denn die Fehler wurden vors&auml;tzlich oder grob fahrl&auml;ssig aufgenommen. Dies bezieht sich auf eventuelle Sch&auml;den materieller oder ideeller Art Dritter, die durch die Nutzung dieses Webangebotes verursacht wurden.


			Urheberrrecht

			Copyright 2007 schuett-biotec GmbH

			Alle Rechte vorbehalten.


			Die auf der Website verwendeten Texte, Bilder, Graphiken, Ton-, Video- und Animationsdateien unterliegen dem Urheberrecht und anderen Gesetzen zum Schutz des Geistigen Eigentums. Ihre Weitergabe, Ver&auml;nderung, gewerbliche Nutzung oder Verwendung auf anderen Websites ist untersagt. Einige Seiten enthalten Bilder, deren Rechte von Dritten zur Nutzung in dieser Website erworben wurden.

			&copy; schuett-biotec GmbH
		</div>
		<div v-if="language == 'en'" style="white-space: pre-line;">
			You are visiting the homepage of
			<address>
			<b>schuett-biotec GmbH</b><br>
			<b>Rudolf-Wissell-Str. 13</b><br>
			<b>D-37079 Goettingen</b><br>
			<b>Germany</b><br>
			Fon +49 (0) 551/5 04 10-0

			Fax +49 (0) 551/5 04 10-99
			<a>E-Mail</a><br>
			<a href="http://www.schuett-biotec.de">www.schuett-biotec.de</a>
			</address>

			General Manager:

			Andrea Arndt


			Local Court:

			Goettingen


			Trade register number:

			HRB 43 67


			VAT code (according to &sect;27a VAT act)

			DE 247 271 380


			Despite of due inspection of the content, we assume no liability for the content of external links. For the content of linked homepages the corresponding agencies are solely liable.


			Please do not hesitate to contact us, if you have questions.


			We are continuously making the effort to keep our website updated and correct as regards content and completeness. However, we may not totally occurring faults. The company schuett-biotec GmbH does not assume liability for topicality, correctness of content or completeness of the information given in the website unless the errors have been included deliberately or due to gross negligence. This applies to possible physical or imaginary damage of a third party that has been caused by the website.


			Copyright 2007 schuett-biotec GmbH

			All rights reserved.


			All texts, photos, graphics, sound-, video- and animation-files used in this website are subject to the copyright and other laws protecting intellectual property rights. The transmission, alteration, commercial use or use on other website is prohibited. Some pages include pictures that have been acquired by third parties for use in this website.


			&copy; schuett-biotec GmbH
		</div>
	</div>
</template>
<script>
  export default {
    name: 'impressum'
  }
</script>
<style scoped>
	p,address {
		display: block;
	}
	address {
		white-space: pre-line;
		font-style: normal;
	}
	#container {
		margin: 1em;
		color: black;
	}
</style>



// WEBPACK FOOTER //
// src/components/impressum.vue